import type { Messages, TranslationKey } from '@/lib/i18n/types'

export type Vars = Record<string, string | number>

export function t(messages: Messages, key: TranslationKey, vars?: Vars): string {
  const raw = key
    .split('.')
    .reduce<unknown>((o, k) => (o as Record<string, unknown> | undefined)?.[k], messages)
  if (typeof raw !== 'string') {
    if (process.env.NODE_ENV !== 'production') console.warn(`[i18n] missing key: ${key}`)
    return key
  }
  return vars ? raw.replace(/\{(\w+)\}/g, (_, name) => String(vars[name] ?? `{${name}}`)) : raw
}

export function plural(
  messages: Messages,
  count: number,
  keys: { one: TranslationKey; other: TranslationKey },
  vars?: Vars,
): string {
  return t(messages, count === 1 ? keys.one : keys.other, { count, ...vars })
}
